import { Form, FormGroup, Label, Input, Spinner, Button } from "reactstrap";
import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Link, useLocation, NavLink } from "react-router-dom";
import { validZipCode, validate } from "helpers/validations";
import Modal from "react-bootstrap/Modal";
import toastr from "toastr";

import ReCAPTCHA from "react-google-recaptcha";

// Components
import SwitchInp from "Component/SwitchInp/SwitchInp";

// Validation Helpers
import { validateEmail } from "helpers/EmailValidation";

// Store
import { registerUser, getContentPage, uploadFile, postNewCollection } from "store/actions";
import { validatePassword } from "helpers/passwordValidation";
import VerifyEmail from "helpers/VerifyEmail";
import Termscenter from "Pages/Terms/Termscenter";
import Privacycenter from "Pages/Privacypolicy/Privacycenter";
import Serviceagreement from "Pages/serviceAgreement/Serviceagreement";
import Privadoqr from "Pages/Privadosc/Privadoqr";

export default function Artistsubmission() {
  const [isPrivado, setIsPrivado] = useState()
  const location = useLocation()
  useEffect(() => {
    if (location.state && location.state.signUpwithPrivado) {

      setIsPrivado(location.state.signUpwithPrivado)
    }
  }, [location])
  let navigate = useNavigate();
  const dispatch = useDispatch();

  const { settings } = useSelector((state) => state?.Login);
  const { loading } = useSelector((state) => state?.Register);
  const [fieldsError, setfieldsError] = useState();
  const [text, setText] = useState("");
  const [isVerified, setIsVerified] = useState(false);
  const [show, setShow] = useState(false);
  const [verifyStatus, setVerifyStatus] = useState(false);
  const [termOfUse, settermOfUse] = useState(false);
  const [serviceAgree, setserviceAgree] = useState(false);
  const [OpenPrivado, setOpenPrivado] = useState(false)
  const [privacypolicy, setprivacypolicy] = useState(false);
  const [museumDescription, setmuseumDescription] = useState("");
  const maxCharacterCountmuseum = 2500;
  const maxCharacterCount = 60;
  const [Termandcondition, setTermandcondition] = useState({
    tnc: false,
  });
  const [term, setTerm] = useState({
    tcs: false,
  });
  const [privacyPolicy, setPrivacyPolicy] = useState({
    pps: false,
  });
  const [passwordtype, setPasswordType] = useState("password");
  const [passwordtype2, setPasswordType2] = useState("password");

  const pass = () => {
    if (passwordtype === "password") {
      setPasswordType("text")
      return;
    }
    setPasswordType("password")
  }
  const confirmpass = () => {
    if (passwordtype2 === "password") {
      setPasswordType2("text")
      return;
    }
    setPasswordType2("password")
  }

  const [fields, setFields] = useState({
    name: "",
    lastname: "",
    companyName: "",
    profileImage: "",
    role: "ARTIST",
    address: "",
    gender: "",
    city: "",
    email: "",
    mobileNumber: "",
    password: "",
    confirmpassword: "",
    zipcode: "",
    zipcodeError: false,
    state: "",
    country: "",
    website: "",
    socialMedia: "",
    age: "",
    description: "",
    refree_referral_code: ""
  });


  const { content } = useSelector((state) => state?.contentpage);

  const getContent = () => {
    return content?.length && content?.find((item) => item?.slug === "platform-as-a-service-agreement")?.content;

  }

  useEffect(() => {
    dispatch(getContentPage());
    if (localStorage.getItem("referral_code")) {
      setFields((prev) => ({ ...prev, [name + "Error"]: false, ["refree_referral_code"]: localStorage.getItem("referral_code") })
      );
    }
  }, []);


  const {
    name,
    nameError,
    lastname,
    lastnameError,
    companyName,
    companyNameError,
    address,
    addressError,
    profileImage,
    profileImageError,
    city,
    cityError,
    email,
    emailError,
    mobileNumber,
    mobileNumberError,
    role,
    state,
    stateError,
    password,
    confirmpassword,
    passwordError,
    confirmpasswordError,
    zipcode,
    zipcodeError,
    country,
    countryError,
    description,
    descriptionError,

    website,
    // websiteError,
    socialMedia,
    // socialMediaError,
    age,
    ageError,
    gender,
    genderError,
    refree_referral_code


  } = fields;

  // useEffect(() => {
  //   if (Termandcondition.tnc) {
  //     setShow(true);
  //   }
  // }, [Termandcondition.tnc]);

  const onChangeHandler = (e) => {
    e.persist();
    const { value, name } = e.target;
    if ((name == 'address') && (value.length <= maxCharacterCount)) {
      setText(value);
    }
    if ((name == 'description') && (value.length <= maxCharacterCountmuseum)) {
      setmuseumDescription(value);
    }
    setFields((prev) =>
      value !== "" || undefined || null
        ? { ...prev, [name + "Error"]: false, [name]: value }
        : { ...prev, [name + "Error"]: true, [name]: value.trim() }
    );

    setfieldsError((prev) => ({ ...prev, StateError: false }));

  };


  const uploadFileSuccess = (name) => (response) => {
    const { _id, link, message } = response.data;
    setFields((prev) => ({ ...prev, profileImage: _id }));
    setfieldsError((prev) => ({ ...prev, mediaError: false }));
    onChangeHandler(name)({ target: { value: _id } });
    if (name == "media") setFields((prev) => ({ ...prev, imgType: link }));
  };

  const handleImageChange = (name) => (evt) => {
    const image = evt.target.files;
    const ext = image[0].name.split(".").pop();
    if (
      ext !== "png" &&
      ext !== "jpg" &&
      ext !== "jpeg"

    ) {
      return toastr.error("Only png, jpg extensions allowed");

    }
    if (image[0] && image[0].size >= 1.04e6 + 24) {
      toastr.error("Please upload a file smaller than 1 MB");
      return false;
    }
    if (image && image[0]) {
      dispatch(uploadFile({ image: image[0] }, uploadFileSuccess("media")));
      setFields((prevState) => ({
        ...prevState,
        imagePreview: URL.createObjectURL(image[0]),
        imageRaw: image[0],
        fileType: evt.target.files[0].type,
        profileImage: image[0],
      }));
    }
  };


  const onSubmit = (e) => {
    e.preventDefault();

    let response = validate(fields);

    setFields((prev) => ({ ...prev, ...response }));
    if (!fields?.profileImage) {
      setFields((prev) => ({ ...prev, profileImage: "653a0ed7cc09d1064302c8bf" }));

    }
    if (fields?.name.trim() === '') {
      return toastr.error("First name is required");

    }
    if (fields?.lastname.trim() === '') {
      return toastr.error("Last name is required");
    }

    if (fields?.mobileNumber.trim() === '') {
      return toastr.error("Phone number is required");
    }
    if (fields?.mobileNumber?.length < 10) {
      return toastr.error("Phone number must be at least 10 numbers");
    }
    if (fields?.email.trim() === '') {
      return toastr.error("Email is required.");

    }
    if (!validateEmail(fields?.email)) {
      toastr.error("Email is not valid.");
      return;
    }
    if (fields?.gender.trim() === '') {
      return toastr.error("Gender is required");
    }
    if (fields?.age.trim() === '') {
      return toastr.error("Age is required");
    }
    if (fields?.age < 18) {
      return toastr.error("Age should be minimum 18 year");
    }
    if (fields?.password.trim() === '') {
      return toastr.error("Password is required");
    }
    if (!validatePassword(fields?.password)) {
      toastr.error("Password should be a minimum of 6 characters, it must include a lower case, upper case and a special character along with a number.");
      return;
    }
    if (fields?.confirmpassword.trim() === '') {
      return toastr.error("Confirm password is required");
    }

    if (fields?.password !== fields?.confirmpassword) {
      return toastr.error("Confirm password does not match");
    }


    if (fields?.address.trim() === '') {
      return toastr.error("Address is required");
    }
    if (fields?.country.trim() === '') {
      return toastr.error("Country is required");
    }
    if (fields?.state.trim() === '') {
      return toastr.error("State is required");
    }
    if (fields?.city.trim() === '') {
      return toastr.error("City is required");
    }
    if (fields?.zipcode?.length < 1) {
      setFields((p) => ({ ...p, zipcodeError: true }))
      return toastr.error("Zip code is required");
    }
    if (fields?.zipcode?.length > 9) {
      setFields((p) => ({ ...p, zipcodeError: true }))
      return toastr.error("Zip code should not be greater then 9 characters");
    }
    if (!validZipCode(fields?.zipcode)) {
      setFields((p) => ({ ...p, zipcodeError: true }))
      return toastr.error("Special characters are not allowed in zip code")
    }

    if (!fields?.description) {
      return toastr.error("Description is required")
    }


    if (isVerified) {
      setShow(true);
    } else {
      toastr.error("Please verify that you are not a robot");
    }
  };

  function closedialogBox() {
    setVerifyStatus(false)
    navigate("/login");
  }

  function handleVerify(response) {
    if (response) {
      setIsVerified(true);
    } else {
      setIsVerified(false);
    }
  }
  function removeImage() {
    setFields((prevState) => ({
      ...prevState,
      imagePreview: "",
      imageRaw: "",
      fileType: "",
      profileImage: ""
    }));
  }

  function termsAndCon() {
    setShow(true);
  }

  const handleClose = () => {
    setShow(false);
  };

  const finalSubmit = (e) => {
    e.preventDefault()
    if (Termandcondition?.tnc == false) {
      return toastr.error("Please Accept Terms & Condition");
    }

    const Registerdata = {
      name: name?.trim(),
      companyName: companyName?.trim(),
      lastname: lastname?.trim(),
      role: "ARTIST",
      address: address?.trim(),
      gender,
      age,
      profileImage,
      city: city?.trim(),
      email,
      username: email,
      mobileNumber,
      password,
      zipcode,
      state: state?.trim(),
      country,
      website,
      socialMedia,
      description,
      verificationProfileStatus: "accept",
      refree_referral_code
    };
    const callback = (res) => {
      const { message, status } = res;
      if (status === "failure") {
        toastr.error(message);
        setShow(false);

      } else {
        if (location.state && location.state.signUpwithPrivado === "privado") {
          setOpenPrivado(!OpenPrivado)
        }
        const colletctiondata = {
          name: name?.trim() + " collection",
          description: "Explore NFTs",
          status: true,
          email: email,
          image: profileImage
        }
        dispatch(
          postNewCollection(colletctiondata)
        );
        setVerifyStatus(true);
        setShow(false);
      }
    };
    dispatch(registerUser(Registerdata, callback));

  };
  function termofService() {
    settermOfUse(true)
  }
  function serviceag() {
    setserviceAgree(true)
  }
  function privacyPolicycont() {
    setprivacypolicy(true)
  }
  function closeTerms() {
    settermOfUse(false)
    setprivacypolicy(false)
    setserviceAgree(false)

  }
  useEffect(() => {
    document.querySelectorAll('textarea').forEach((el) => {
      el.style.height = el.setAttribute('style', 'height: ' + el.scrollHeight + 'px');
      el.classList.add('auto');
      el.addEventListener('input', e => {
        el.style.height = 'auto';
        el.style.height = (el.scrollHeight) + 'px';
      })
    })
  }, [])

  const Privado = () => {
    setOpenPrivado(!OpenPrivado)
  }
  return (
    <>
      <div className="artist-div">
        <Modal className="artist-modal" size="lg" show={show} centered animation={false}>
          <form>
            <div className="term_userdiv ">
              <div className="term-content-container">
                <div
                  dangerouslySetInnerHTML={{
                    __html: getContent()
                      ? getContent()
                      : "Loading...",
                  }}
                />


                <div className="CustomeCheckBox mb-2">
                  <SwitchInp
                    enabled={Termandcondition?.tnc}
                    handleChangeFun={setTermandcondition}
                    name="tnc" id="tnc"
                  /> <label htmlFor="tnc"></label>

                  <span onClick={serviceag} className="link_text mb-0 cursor-pointer" >  I agree platform as a service agreement</span>


                </div>
                <div className="CustomeCheckBox mb-2">
                  <SwitchInp
                    enabled={term?.tcs}
                    handleChangeFun={setTerm}
                    name="tcs" id="tcs"
                  />  <label htmlFor="tcs"></label>
                  <span onClick={termofService} className="link_text mb-0 cursor-pointer" >I agree, terms of service</span>

                </div>

                <div className="CustomeCheckBox mb-2">
                  <SwitchInp
                    enabled={privacyPolicy.pps}
                    handleChangeFun={setPrivacyPolicy}
                    name="pps" id="pps"
                  /> <label htmlFor="pps"></label>
                  <span onClick={privacyPolicycont} className="link_text mb-0 cursor-pointer" >I agree, privacy policy</span>
                </div>
              </div>
              <div className="termsBtn">
                <div className="textscrollmsg mb-3">
                  <div className="scrollIcon">
                    <i className="fa-light fa-angles-down"></i>
                  </div>
                  <p className="mb-0">Please scroll below  to check all agreement before accepting</p>
                </div>
                <Button
                  variant="danger"
                  className="cancel_btn"
                  onClick={handleClose}
                >
                  Close
                </Button>
                <Button
                  variant="secondary"
                  className="success_btn"
                  onClick={(e) => finalSubmit(e)}
                  disabled={!Termandcondition?.tnc || !term?.tcs || !privacyPolicy?.pps}
                >
                  Accept
                </Button>
              </div>
            </div>
          </form>
        </Modal>
      </div>
      <Modal className="termandCoDialog" show={serviceAgree} centered animation={false}>
        <div className="text-end">
          <button onClick={closeTerms} className="btn cancelbtn end-0 top-0"><img src="/images/svg/closeIconDialog.svg" alt="" /></button>
        </div>
        <div className="contentBoxdialog">
          <Serviceagreement />
          {content && <button className="btn btn-primary px-5 btn-sm py-2" onClick={closeTerms}>Back</button>}
        </div>

      </Modal>
      <Modal className="termandCoDialog" show={termOfUse} centered animation={false}>
        <div className="text-end">
          <button onClick={closeTerms} className="btn cancelbtn end-0 top-0"><img src="/images/svg/closeIconDialog.svg" alt="" /></button>
        </div>
        <div className="contentBoxdialog">
          <Termscenter />
          {content && <button className="btn btn-primary px-5 btn-sm py-2" onClick={closeTerms}>Back</button>}
        </div>

      </Modal>
      <Modal className="termandCoDialog" show={privacypolicy} centered animation={false}>
        <div className="text-end">
          <button onClick={closeTerms} className="btn cancelbtn end-0 top-0"><img src="/images/svg/closeIconDialog.svg" alt="" /></button>
        </div>
        <div className="contentBoxdialog">
          <Privacycenter />
          {content && <button className="btn btn-primary px-5 btn-sm py-2" onClick={closeTerms}>Back</button>}
        </div>
      </Modal>
      <Modal className="EmailVerifyBoxModel text-center" size="md" show={verifyStatus} centered animation={false}>
        <VerifyEmail />
        <button className="btn btn-primary btn-sm py-2 text-white" onClick={closedialogBox}>Close</button>
      </Modal>

      <section className="container-fluid artist-register-page p-0">
        <div className="row g-0 min-vh-100">

          {/* Left image section — image path remains unchanged */}
          <Col
            lg={7}
            className="artist-register-image-column d-none d-lg-block p-0"
          >
            <div className="artist-register-image-wrapper">
              <img
                src="../../images/artistRegist.png"
                className="artist-register-image"
                alt="Login"
              />
            </div>
          </Col>

          {/* Right form section */}
          <Col
            xs={12}
            lg={5}
            className="artist-register-form-column p-0 bg-white"
          >
            <div className="artist-register-scroll">
              <div className="artist-register-content mx-auto px-3 px-sm-4 px-xl-5 py-4 py-lg-5">

                {/* Logo */}
                {/* Logo */}
                <div className="museum-register-logo text-center mb-3">
                  <a
                    href="https://terpnash.com/"
                    rel="noreferrer"
                    className="navbar-brand d-inline-block p-0 m-0"
                  >
                    {settings?.logo?.link && (
                      <>
                        {settings?.logo?.link.search(".mp4") !== -1 ? (
                          <img
                            src={settings?.logo?.link || "/images/t3.gif"}
                            alt="Terpnash logo"
                            className="img-fluid"
                          />
                        ) : (
                          <img
                            src={settings?.logo?.link || "/images/t3.gif"}
                            alt="Terpnash logo"
                            className="img-fluid logodesktop"
                          />
                        )}
                      </>
                    )}
                  </a>
                </div>

                {/* Page heading */}
                <div className="text-center mb-4">
                  <h1 className="user-register-title  mb-2 LR-heading">
                    Create your Account
                  </h1>

                  <p className="user-register-subtitle LR-subheading mb-4">
                    Join artists, museums and Collectors from around the world
                  </p>

                  <h5 className="user-account-heading LR-heading mb-3">
                    Choose your account type
                  </h5>

                  {/* Account tabs */}
                  <div className="user-account-tabs d-flex align-items-center p-1">
                    <NavLink
                      className={({ isActive }) =>
                        `user-account-tab flex-fill ${isActive ? "active gardient-button" : ""
                        }`
                      }
                      to="/users/register"
                      state={{ signUpwithPrivado: isPrivado }}
                    >
                      Buyer
                    </NavLink>

                    <NavLink
                      className={({ isActive }) =>
                        `user-account-tab flex-fill ${isActive ? "active gardient-button" : ""
                        }`
                      }
                      to="/artist/register"
                      state={{ signUpwithPrivado: isPrivado }}
                    >
                      Artist
                    </NavLink>

                    <NavLink
                      className={({ isActive }) =>
                        `user-account-tab flex-fill ${isActive ? "active gardient-button" : ""
                        }`
                      }
                      to="/museums/register"
                      state={{ signUpwithPrivado: isPrivado }}
                    >
                      Museum
                    </NavLink>
                  </div>
                </div>

                <Form className="registration-here">

                  {/* Basic Information */}
                  <div className="artist-form-section mb-4">
                    <h2 className="user-section-title LR-heading mb-0">
                      Basic Information
                    </h2>

                    {/* Profile image upload */}
                    <div className="d-flex flex-column align-items-center text-center mb-4">
                      {fields?.imagePreview ? (
                        <div className="position-relative">
                          <button
                            type="button"
                            onClick={removeImage}
                            className="artist-profile-remove btn p-0 position-absolute"
                          >
                            <i className="fa-regular fa-xmark"></i>
                          </button>

                          <label
                            htmlFor="inputGroupFile01"
                            className="artist-profile-upload overflow-hidden"
                          >
                            <img
                              src={
                                fields?.imagePreview ||
                                "img/upload-img.png"
                              }
                              className="w-100 h-100"
                              alt="Profile preview"
                            />
                          </label>

                          <input
                            className="d-none"
                            name="profileImage"
                            type="file"
                            id="inputGroupFile01"
                            onChange={handleImageChange("profileImage")}
                            accept="image/*"
                          />
                        </div>
                      ) : (
                        <>
                          <label
                            htmlFor="inputGroupFile01"
                            className="artist-profile-upload"
                          >
                            <i className="fa-regular fa-camera"></i>
                          </label>

                          <input
                            className="d-none"
                            name="image"
                            type="file"
                            id="inputGroupFile01"
                            onChange={handleImageChange("image")}
                            accept="image/*"
                          />
                        </>
                      )}

                      <p className="user-upload-title mt-3 mb-1 LR-subheading">
                        Upload Profile Photo
                      </p>
                      <p className="user-upload-description mb-0 LR-subheading">
                       Click to upload an image · JPG / PNG up to 1MB
                      </p>
                    </div>

                    <Row className="g-6">

                      {/* First name */}
                      <Col xs={12} md={6}>
                        <FormGroup className="mb-0">
                          <Label
                            htmlFor="name"
                            className="artist-form-label LR-subheading"
                          >
                            First Name
                          </Label>

                          <Input
                            type="text"
                            placeholder="First Name"
                            name="name"
                            id="name"
                            value={name}
                            invalid={nameError}
                            required={nameError}
                            onChange={onChangeHandler}
                            maxLength={30}
                            className="artist-form-control"
                          />
                        </FormGroup>
                      </Col>

                      {/* Last name */}
                      <Col xs={12} md={6}>
                        <FormGroup className="mb-0">
                          <Label
                            htmlFor="lastname"
                            className="artist-form-label LR-subheading"
                          >
                            Last Name
                          </Label>

                          <Input
                            type="text"
                            placeholder="Last Name"
                            name="lastname"
                            id="lastname"
                            value={lastname}
                            invalid={lastnameError}
                            required={lastnameError}
                            onChange={onChangeHandler}
                            maxLength={30}
                            className="artist-form-control"
                          />
                        </FormGroup>
                      </Col>

                      {/* Company name */}
                      <Col xs={12}>
                        <FormGroup className="mb-0">
                          <Label
                            htmlFor="companyName"
                            className="artist-form-label LR-subheading"
                          >
                            Company Name
                            {/* <span className="text-secondary fw-normal">
                        {" "}(Optional)
                      </span> */}
                          </Label>

                          <Input
                            type="text"
                            placeholder="Company Name"
                            name="companyName"
                            id="companyName"
                            value={companyName}
                            onChange={onChangeHandler}
                            className="artist-form-control"
                          />
                        </FormGroup>
                      </Col>

                      {/* Phone */}
                      <Col xs={12} md={6}>
                        <FormGroup className="mb-0">
                          <Label
                            htmlFor="mobileNumber"
                            className="artist-form-label LR-subheading"
                          >
                            Phone Number
                          </Label>

                          <Input
                            type="number"
                            maxLength="11"
                            placeholder="Phone Number"
                            min="1"
                            name="mobileNumber"
                            id="mobileNumber"
                            value={mobileNumber}
                            invalid={mobileNumberError}
                            required={mobileNumberError}
                            onChange={onChangeHandler}
                            className="artist-form-control"
                          />
                        </FormGroup>
                      </Col>

                      {/* Email */}
                      <Col xs={12} md={6}>
                        <FormGroup className="mb-0">
                          <Label
                            htmlFor="email"
                            className="artist-form-label LR-subheading"
                          >
                            Email
                          </Label>

                          <Input
                            pattern={
                              fields?.email == ".+@gmail.com" ||
                              fields?.email == ".com"
                            }
                            placeholder="Email"
                            type="email"
                            name="email"
                            id="email"
                            value={email}
                            invalid={emailError}
                            required={emailError}
                            onChange={onChangeHandler}
                            className="artist-form-control"
                          />
                        </FormGroup>
                      </Col>

                      {/* Gender */}
                      <Col xs={12} md={6}>
                        <FormGroup className="mb-0">
                          <Label
                            htmlFor="gender"
                            className="artist-form-label LR-subheading"
                          >
                            Select Gender
                          </Label>

                          <Input
                            type="select"
                            name="gender"
                            id="gender"
                            value={gender}
                            invalid={genderError}
                            required={genderError ? genderError : true}
                            onChange={onChangeHandler}
                            className="artist-form-control form-select"
                          >
                            <option value="" disabled>
                              Select Gender
                            </option>

                            <option>Male</option>
                            <option>Female</option>
                            <option>Prefer Not to Say</option>
                          </Input>
                        </FormGroup>
                      </Col>

                      {/* Age */}
                      <Col xs={12} md={6}>
                        <FormGroup className="mb-0">
                          <Label
                            htmlFor="age"
                            className="artist-form-label LR-subheading"
                          >
                            Age
                          </Label>

                          <Input
                            type="number"
                            placeholder="Age"
                            name="age"
                            id="age"
                            value={age}
                            invalid={ageError}
                            required={ageError}
                            onChange={onChangeHandler}
                            className="artist-form-control"
                          />
                        </FormGroup>
                      </Col>

                      {/* Password */}
                      <Col xs={12} md={6}>
                        <FormGroup className="mb-0">
                          <Label
                            htmlFor="password"
                            className="artist-form-label LR-subheading"
                          >
                            Password
                          </Label>

                          <div className="position-relative">
                            <Input
                              placeholder="Password"
                              type={passwordtype}
                              className="artist-form-control pe-5"
                              name="password"
                              id="password"
                              value={password}
                              invalid={passwordError}
                              required={passwordError}
                              onChange={onChangeHandler}
                            />

                            <button
                              type="button"
                              onClick={pass}
                              className="artist-password-button btn border-0 position-absolute"
                            >
                              {passwordtype === "password" ? (
                                <i className="fa-light fa-eye-slash"></i>
                              ) : (
                                <i className="fa-light fa-eye"></i>
                              )}
                            </button>
                          </div>
                        </FormGroup>
                      </Col>

                      {/* Confirm password */}
                      <Col xs={12} md={6}>
                        <FormGroup className="mb-0">
                          <Label
                            htmlFor="confirmpassword"
                            className="artist-form-label LR-subheading"
                          >
                            Confirm Password
                          </Label>

                          <div className="position-relative">
                            <Input
                              placeholder="Confirm Password"
                              type={passwordtype2}
                              className="artist-form-control pe-5"
                              name="confirmpassword"
                              id="confirmpassword"
                              value={confirmpassword}
                              invalid={confirmpasswordError}
                              required={confirmpasswordError}
                              onChange={onChangeHandler}
                            />
                            <button
                              type="button"
                              onClick={confirmpass}
                              className="artist-password-button btn border-0 position-absolute"
                            >
                              {passwordtype2 === "password" ? (
                                <i className="fa-light fa-eye-slash"></i>
                              ) : (
                                <i className="fa-light fa-eye"></i>
                              )}
                            </button>
                          </div>
                        </FormGroup>
                      </Col>
                    </Row>
                  </div>

                  {/* Address section */}
                  <div className="user-form-section mb-1">
                    <h2 className="user-section-title-log LR-heading mb-3">
                      Address
                    </h2>

                    <Row className="">

                      {/* Full address */}
                      <Col xs={12}>
                        <FormGroup className="mb-0">
                          <Label
                            htmlFor="address"
                            className="user-form-label LR-subheading"
                          >
                            Full Address
                          </Label>

                          <div className="position-relative">
                            <Input
                              type="textarea"
                              maxLength={60}
                              value={address}
                              placeholder="Full Address"
                              invalid={addressError}
                              name="address"
                              id="address"
                              required={addressError}
                              onChange={onChangeHandler}
                              className="artist-form-control artist-address-control pb-4"
                            />

                            <span className="artist-character-count">
                              {maxCharacterCount - text.length}/
                              {maxCharacterCount}
                            </span>
                          </div>
                        </FormGroup>
                      </Col>

                      {/* City */}
                      <Col xs={12} md={6}>
                        <FormGroup className="mb-0">
                          <Label
                            htmlFor="city"
                            className="artist-form-label LR-subheading"
                          >
                            City
                          </Label>

                          <Input
                            type="text"
                            name="city"
                            id="city"
                            placeholder="City"
                            value={city}
                            invalid={cityError}
                            required={cityError}
                            onChange={onChangeHandler}
                            className="artist-form-control"
                          />
                        </FormGroup>
                      </Col>

                      {/* State */}
                      <Col xs={12} md={6}>
                        <FormGroup className="mb-0">
                          <Label
                            htmlFor="state"
                            className="artist-form-label LR-subheading"
                          >
                            State
                          </Label>

                          <Input
                            type="text"
                            name="state"
                            id="state"
                            placeholder="State"
                            value={state}
                            invalid={stateError}
                            required={stateError}
                            onChange={onChangeHandler}
                            className="artist-form-control"
                          />
                        </FormGroup>
                      </Col>

                      {/* Country */}
                      <Col xs={12} md={6}>
                        <FormGroup className="mb-0">
                          <Label
                            htmlFor="country"
                            className="artist-form-label LR-subheading"
                          >
                            Country
                          </Label>

                          <Input
                            type="select"
                            name="country"
                            id="country"
                            value={country}
                            invalid={countryError}
                            required
                            onChange={onChangeHandler}
                            className="artist-form-control form-select"
                          >
                            <option value="" disabled>
                              Select Country
                            </option>

                            {[
                              "Afghanistan",
                              "Albania",
                              "Algeria",
                              "American Samoa",
                              "Andorra",
                              "Angola",
                              "Anguilla",
                              "Antigua",
                              "Argentina",
                              "Armenia",
                              "Aruba",
                              "Australia",
                              "Austria",
                              "Azerbaijan",
                              "Bahrain",
                              "Bangladesh",
                              "Barbados",
                              "Burkina Faso",
                              "Brazil",
                              "Belarus",
                              "Brazil",
                              "Belarus",
                              "Belgium",
                              "Belize",
                              "Benin",
                              "Bermuda",
                              "Bhutan",
                              "Bolivia",
                              "Bosnia and Herzegovina",
                              "Botswana",
                              "Bulgaria",
                              "Burundi",
                              "Bonaire, Sint Eustatius and Saba",
                              "British Virgin Islands",
                              "British Indian Ocean Territory",
                              "Brunei",
                              "Côte d'Ivoire",
                              "Central African Republic",
                              "China",
                              "Chad",
                              "Chile",
                              "Curaçao",
                              "Croatia",
                              "Cape Verde",
                              "Colombia",
                              "Costa Rica",
                              "Cuba",
                              "Canada",
                              "Cambodia",
                              "Cook Islands",
                              "Czech Republic",
                              "Cayman Islands",
                              "Comoros",
                              "Cyprus",
                              "Denmark",
                              "Djibouti",
                              "Dominican Republic",
                              "Dominica",
                              "Democratic Republic of the Congo",
                              "Egypt",
                              "Ethiopia",
                              "Estonia",
                              "Ecuador",
                              "El Salvador",
                              "Eritrea",
                              "Equatorial Guinea",
                              "France",
                              "French Guiana",
                              "French Polynesia",
                              "Fiji",
                              "Finland",
                              "Falkland Islands",
                              "Faroe Islands",
                              "Federated States of Micronesia",
                              "Georgia",
                              "Grenada",
                              "Greenland",
                              "Guadeloupe",
                              "Guam",
                              "Guernsey",
                              "Guyana",
                              "Ghana",
                              "Guinea",
                              "Gabon",
                              "Guatemala",
                              "Greece",
                              "Gibraltar",
                              "Guinea-Bissau",
                              "Haiti",
                              "Honduras",
                              "Hong Kong",
                              "Hungary",
                              "Iceland",
                              "Isle Of Man",
                              "Iran",
                              "Italy",
                              "Iraq",
                              "India",
                              "Israel",
                              "Indonesia",
                              "Ireland",
                              "Jordan",
                              "Jamaica",
                              "Jersey",
                              "Japan",
                              "Kenya",
                              "Kiribati",
                              "Kazakhstan",
                              "Kyrgyzstan",
                              "Kuwait",
                              "Kosovo",
                              "Lithuania",
                              "Liberia",
                              "Libya",
                              "Latvia",
                              "Lesotho",
                              "Laos",
                              "Lebanon",
                              "Liechtenstein",
                              "Luxembourg",
                              "Macau",
                              "Maldives",
                              "Malta",
                              "Malawi",
                              "Malaysia",
                              "Montenegro",
                              "Mali",
                              "Macedonia",
                              "Marshall Islands",
                              "Martinique",
                              "Mayotte",
                              "Mauritius",
                              "Mauritania",
                              "Mongolia",
                              "Montserrat",
                              "Myanmar",
                              "Moldova",
                              "Morocco",
                              "Monaco",
                              "Mexico",
                              "Mozambique",
                              "Madagascar",
                              "Northern Mariana Islands",
                              "North Korea",
                              "New Zealand",
                              "New Caledonia",
                              "Norway",
                              "Nauru",
                              "Namibia",
                              "Nepal",
                              "Nicaragua",
                              "Niger",
                              "Norfolk Island",
                              "Netherlands",
                              "Nigeria",
                              "Niue",
                              "Oman",
                              "Portugal",
                              "Peru",
                              "Palau",
                              "Poland",
                              "Paraguay",
                              "Pakistan",
                              "Panama",
                              "Philippines",
                              "Palestine",
                              "Puerto Rico",
                              "Papua New Guinea",
                              "Qatar",
                              "Republic of the Congo",
                              "Russia",
                              "Réunion",
                              "Rwanda",
                              "Romania",
                              "Saint Pierre and Miquelon",
                              "Saint Helena",
                              "Saint Martin",
                              "Saint Kitts and Nevis",
                              "Sint Maarten",
                              "San Marino",
                              "Saint Vincent and the Grenadines",
                              "Sri Lanka",
                              "Slovakia",
                              "Slovenia",
                              "Sudan",
                              "Swaziland",
                              "Sweden",
                              "Switzerland",
                              "South Africa",
                              "South Sudan",
                              "Samoa",
                              "Serbia",
                              "Sierra Leone",
                              "Senegal",
                              "Seychelles",
                              "Saudi Arabia",
                              "Saint Barthélemy",
                              "Suriname",
                              "Solomon Islands",
                              "Somalia",
                              "Saint Lucia",
                              "South Korea",
                              "Sao Tome and Principe",
                              "Singapore",
                              "Syria",
                              "Spain",
                              "The Bahamas",
                              "The Gambia",
                              "Timor-Leste",
                              "Taiwan",
                              "Tajikistan",
                              "Thailand",
                              "Tonga",
                              "Tanzania",
                              "Trinidad and Tobago",
                              "Turks and Caicos Islands",
                              "Tunisia",
                              "Tuvalu",
                              "Turkey",
                              "Tokelau",
                              "Turkmenistan",
                              "Togo",
                              "Uganda",
                              "Ukraine",
                              "United Arab Emirates",
                              "United Kingdom",
                              "United States",
                              "Uruguay",
                              "Uzbekistan",
                              "Vatican City",
                              "Venezuela",
                              "Vanuatu",
                              "Vietnam",
                              "Wallis and Futuna",
                              "Western Sahara",
                              "Yemen",
                              "Zambia",
                              "Zimbabwe",
                            ].map((countryItem, index) => (
                              <option
                                value={countryItem}
                                key={`${countryItem}-${index}`}
                              >
                                {countryItem}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>
                      </Col>

                      {/* ZIP */}
                      <Col xs={12} md={6}>
                        <FormGroup className="mb-0">
                          <Label
                            htmlFor="zipcode"
                            className="artist-form-label LR-subheading"
                          >
                            ZIP
                          </Label>

                          <Input
                            type="text"
                            name="zipcode"
                            id="zipcode"
                            placeholder="ZIP Code"
                            maxLength={9}
                            value={zipcode}
                            invalid={zipcodeError}
                            required={zipcodeError}
                            onChange={onChangeHandler}
                            className="artist-form-control"
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </div>

                  {/* Other section */}
                  <div className="artist-form-section mb-3">
                    <h2 className="artist-section-title mb-3">
                      Other
                    </h2>

                    <Row className="">

                      {/* Website */}
                      <Col xs={12}>
                        <FormGroup className="mb-0">
                          <Label
                            htmlFor="website"
                            className="artist-form-label LR-subheading"
                          >
                            Website
                          </Label>

                          <Input
                            type="text"
                            placeholder="Website (Optional)"
                            name="website"
                            id="website"
                            value={website}
                            onChange={onChangeHandler}
                            className="artist-form-control"
                          />
                        </FormGroup>
                      </Col>

                      {/* Biography */}
                      <Col xs={12}>
                        <FormGroup className="mb-0">
                          <Label
                            htmlFor="description"
                            className="artist-form-label LR-subheading"
                          >
                            Bio
                          </Label>

                          <div className="position-relative">
                            <Input
                              type="textarea"
                              maxLength={2500}
                              placeholder="Write here..."
                              name="description"
                              id="description"
                              className="artist-form-control artist-bio-control pb-4"
                              value={description}
                              invalid={descriptionError}
                              required={descriptionError}
                              onChange={onChangeHandler}
                            />

                            <span className="artist-character-count">
                              {maxCharacterCountmuseum -
                                museumDescription.length}
                              /{maxCharacterCountmuseum}
                            </span>
                          </div>
                        </FormGroup>
                      </Col>

                      {/* Referral code */}
                      <Col xs={12}>
                        <FormGroup className="mb-0">
                          <Label
                            htmlFor="refree_referral_code"
                            className="artist-form-label LR-subheading"
                          >
                            Referral Code
                          </Label>

                          <Input
                            type="text"
                            name="refree_referral_code"
                            id="refree_referral_code"
                            placeholder="Referral Code"
                            value={fields?.refree_referral_code}
                            onChange={onChangeHandler}
                            className="artist-form-control"
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </div>

                  {/* Existing captcha */}
                  <div className="artist-captcha-wrapper d-flex justify-content-flex mb-4">
                    <ReCAPTCHA
                      sitekey={
                        settings?.googleCaptchaKey?.captchaKey ||
                        "6LfHhHgmAAAAAMDY7S-sxLljqfIE6ku1u1zYWNi2"
                      }
                      onChange={(e) => handleVerify(e)}
                    />
                  </div>

                  {/* Existing submit */}
                  <div className="text-center">
                    <button
                      onClick={onSubmit}
                      className={
                        isPrivado === "privado"
                          ? "registrationBtn artist-create-account-button w-100 prevadobtnnew"
                          : "registrationBtn artist-create-account-button w-100"
                      }
                      type="submit"
                    >
                      Create Account{" "}

                      {loading ? (
                        <Spinner
                          animation="border"
                          size="sm"
                          role="status"
                        />
                      ) : (
                        ""
                      )}
                    </button>
                  </div>

                  {/* Login */}
                  <div className="text-center mt-4">
                    <p className="artist-login-text mb-0">
                      Already have an account?{" "}

                      <Link
                        to="/login"
                        className="artist-login-link"
                      >
                        Login
                      </Link>
                    </p>
                  </div>
                </Form>
              </div>
            </div>
          </Col>
        </div>
      </section>
      {OpenPrivado == true && <div className="barcodeBoxMaine barcodeafterlogin">
        <Privadoqr func={Privado} />

      </div>}
    </>
  );
}
